import styled, { css } from 'styled-components';
import { switchProp } from 'styled-tools';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { media } from '../../mixins/media.js';
import { textStyle } from '../../mixins/textStyle.js';

const SidebarItemArrow = background => css(["position:absolute;top:0;right:-12px;content:'';width:0;height:0;border-style:solid;border-width:20px 0 22px 12px;border-color:transparent transparent transparent ", ";"], ({
  theme
}) => theme.components.sidebar[background]);
const SidebarItemIcon = styled.svg.withConfig({
  componentId: "sc-k39njx-0"
})(["margin-top:2px;margin-right:", ";flex-shrink:0;"], ({
  theme
}) => theme.components.sidebar.iconMargin);
const SidebarItem = css(["", ";", ";position:relative;z-index:1;display:inline-flex;cursor:pointer;text-decoration:none;text-align:left;border:none;width:100%;background:transparent;padding:", ";color:", ";&:focus{outline:none;background-color:", ";}&:hover{text-decoration:underline;}", ""], defaultStyles.boxSizing, textStyle('label'), ({
  theme
}) => theme.components.sidebar.itemPadding, ({
  theme
}) => theme.components.sidebar.itemColor, ({
  theme
}) => theme.components.sidebar.itemBackgroundColorHover, ({
  theme
}) => switchProp('depth', {
  0: css(["&:hover{background-color:", ";}"], theme.components.sidebar.itemBackgroundColorHover),
  1: css(["&:focus,&:hover{background-color:", ";}"], theme.components.sidebar.subItemBackgroundColorHover)
}));
const SidebarButton = styled.button.attrs(({
  type = 'button'
}) => ({
  type
})).withConfig({
  componentId: "sc-k39njx-1"
})(["", " ", " ", ""], SidebarItem, ({
  isSelected
}) => isSelected && css(["z-index:2;", ";"], textStyle('labelBold')), ({
  theme,
  isSelected
}) => switchProp('depth', {
  0: css(["", ""], isSelected && css(["border-left:", ";padding-left:", ";background-color:", ";&::after{", "}"], theme.components.sidebar.itemBorderActive, theme.components.sidebar.itemPaddingLeftActive, theme.components.sidebar.itemBackgroundColorActive, media.greaterThan('s')`${SidebarItemArrow('itemBackgroundColorHover')}`)),
  1: css(["", " &:focus,&:hover{background-color:", ";}"], isSelected && css(["background-color:", ";&::after{", "}"], theme.components.sidebar.subItemBackgroundColorHover, media.greaterThan('s')`${SidebarItemArrow('subItemBackgroundColorHover')}`), theme.components.sidebar.subItemBackgroundColorHover)
}));
const SidebarLink = styled.a.withConfig({
  shouldForwardProp: (prop, defaultValidationFn) => defaultValidationFn(prop)
}).withConfig({
  componentId: "sc-k39njx-2"
})(["", " ", ";", ""], SidebarItem, ({
  isRouteActive
}) => isRouteActive && css(["", ";background-color:", ";"], textStyle('labelBold'), ({
  theme
}) => theme.components.sidebar.itemBackgroundColorActive), ({
  isRouteActive,
  theme
}) => isRouteActive && switchProp('depth', {
  0: css(["border-left:", ";padding-left:", ";"], theme.components.sidebar.itemBorderActive, theme.components.sidebar.itemPaddingLeftActive),
  1: css(["background-color:", ";"], theme.components.sidebar.subItemBackgroundColorActive)
}));

export { SidebarButton, SidebarItemIcon, SidebarLink };
//# sourceMappingURL=SidebarItem.js.map
